// Centralne miejsce na wartości domenowe wyprowadzone ze zmiennych środowiskowych
// REACT_APP_*. Fallbacki odpowiadają dzisiejszym zaszytym w kodzie wartościom, tak by
// przeniesienie serwisu na inną domenę było zmianą konfiguracji, a nie kodu.

export const APP_URL = process.env.REACT_APP_APP_URL || 'https://staging.votenti.pl';
export const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL || 'biuro@votenti.pl';
export const BILLING_EMAIL = process.env.REACT_APP_BILLING_EMAIL || 'platnosci@votenti.pl';
